import { render, staticRenderFns } from "./ModalDocumentChecklist.vue?vue&type=template&id=0b71b864&scoped=true&"
import script from "./ModalDocumentChecklist.vue?vue&type=script&lang=js&"
export * from "./ModalDocumentChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b71b864",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b71b864')) {
      api.createRecord('0b71b864', component.options)
    } else {
      api.reload('0b71b864', component.options)
    }
    module.hot.accept("./ModalDocumentChecklist.vue?vue&type=template&id=0b71b864&scoped=true&", function () {
      api.rerender('0b71b864', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/eicproducts/heat-pump-rebate/ModalDocumentChecklist.vue"
export default component.exports